import { Facebook, Instagram, Linkedin, MessageCircle } from "lucide-react";

const socialLinks = [
  {
    name: "Facebook",
    icon: Facebook,
    color: "#1877F2",
    bgColor: "bg-[#1877F2]",
    hoverBg: "hover:bg-[#1877F2]",
    text: "Follow us on Facebook for company updates and eco-friendly initiatives.",
    link: "https://www.facebook.com/share/1AsuHVew1F/",
  },
  {
    name: "Instagram",
    icon: Instagram,
    color: "#E4405F",
    bgColor: "bg-gradient-to-br from-[#f09433] via-[#e6683c] to-[#bc1888]",
    hoverBg: "hover:bg-[#E4405F]",
    text: "Explore our eco products, lifestyle inspiration, and sustainability posts.",
    link: "https://www.instagram.com/prithiraglobal?igsh=MXZmcGVsc214eW04NA==",
  },
  {
    name: "LinkedIn",
    icon: Linkedin,
    color: "#0A66C2",
    bgColor: "bg-[#0A66C2]",
    hoverBg: "hover:bg-[#0A66C2]",
    text: "Connect with us for business collaborations, partnerships, and professional updates.",
    link: "https://www.linkedin.com/in/prithira-global-8130a83b6?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  },
  {
    name: "WhatsApp",
    icon: MessageCircle,
    color: "#25D366",
    bgColor: "bg-[#25D366]",
    hoverBg: "hover:bg-[#25D366]",
    text: "Chat with us directly for product enquiries and business orders.",
    link: "https://wa.me/919830195737",
  },
];

const ConnectWithUs = () => {
  return (
    <section
      data-testid="connect-section"
      className="relative py-20 overflow-hidden"
      style={{
        background: "linear-gradient(135deg, #f0f7f0 0%, #e8f5e8 50%, #f5f9f5 100%)",
      }}
    >
      {/* Decorative leaf pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 5c-5 10-15 15-25 15 10 5 15 15 15 25 5-10 15-15 25-15-10-5-15-15-15-25z' fill='%232C5F2D' fill-opacity='1'/%3E%3C/svg%3E")`,
          backgroundSize: "60px 60px",
        }}
      />

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="caption text-primary mb-4 block">Stay Connected</span>
          <h2 className="heading-lg text-stone-900 mb-4">
            Connect With <span className="italic">Prithira Global</span>
          </h2>
          <p className="body-base text-stone-600 max-w-2xl mx-auto">
            Stay connected with us for the latest updates, eco-friendly innovations,
            sustainable lifestyle tips, and product launches.
          </p>
        </div>

        {/* Social Media Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-${social.name.toLowerCase()}`}
              className="group"
            >
              <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-stone-100 h-full flex flex-col items-center text-center">
                {/* Icon Container */}
                <div
                  className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg ${
                    social.name === "Instagram"
                      ? social.bgColor
                      : `bg-stone-100 group-hover:${social.bgColor.replace("bg-", "")}`
                  }`}
                  style={{
                    backgroundColor: social.name !== "Instagram" ? "#f5f5f4" : undefined,
                  }}
                >
                  <social.icon
                    className={`h-8 w-8 transition-colors duration-300 ${
                      social.name === "Instagram"
                        ? "text-white"
                        : "group-hover:text-white"
                    }`}
                    style={{
                      color: social.name !== "Instagram" ? social.color : undefined,
                    }}
                    strokeWidth={1.5}
                  />
                </div>

                {/* Platform Name */}
                <h3 className="font-heading text-lg text-stone-900 mb-2 group-hover:text-primary transition-colors">
                  {social.name}
                </h3>

                {/* Description */}
                <p className="text-stone-500 text-sm font-light leading-relaxed flex-1">
                  {social.text}
                </p>

                {/* Follow Button */}
                <div
                  className="mt-4 px-4 py-2 rounded-full text-xs font-medium transition-all duration-300 border"
                  style={{
                    borderColor: social.color,
                    color: social.color,
                  }}
                >
                  <span className="group-hover:hidden">Follow</span>
                  <span className="hidden group-hover:inline">Connect →</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-stone-600 font-light">
            <span className="text-primary font-medium">Join our community</span> and be
            part of the sustainable revolution!
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConnectWithUs;
